import { contentfulImageUrl } from '@telialt/utils/src/Contentful/contentfulImageUrl';

import { BlogSectionType } from '../../../models/Content';

export const transformSectionImage = (content: BlogSectionType) => {
    const imageAsset = content.fields.images?.[0];

    return {
        url: contentfulImageUrl(imageAsset?.fields?.file?.url),
        alt: imageAsset?.fields?.description,
        width: imageAsset?.fields?.file?.details?.image?.width,
        height: imageAsset?.fields?.file?.details?.image?.height,
    };
};
